import { VendorDetailsWithContractAdmin } from './types'

export const CREATION_ROUTE = 'create'

export const COUNTRIES_LIST = [
  {
    label: 'United States',
    value: 'US'
  },
  {
    label: 'Canada',
    value: 'CA'
  }
]

export const INITIAL_VENDOR_DETAILS: VendorDetailsWithContractAdmin = {
  contract_admin: {
    email: '',
    role: '',
    status: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    avatar: null
  },
  uuid: '',
  name: '',
  description: '',
  phone_number: '',
  address: {
    state: '',
    city: '',
    street: '',
    zip_code: '',
    country: COUNTRIES_LIST[0].value
  },
  contract_steward: {
    email: '',
    role: '',
    status: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    avatar: null
  },
  remit_to_address_set: [],
  order_from_address_set: [],
  alternate_name_set: [],
  business_name: ''
}

export const validateMessages = {
  default: 'Validation error on field ${label}',
  required: '${label} is required',
  whitespace: '${label} cannot be empty',
  types: {
    email: 'Enter a valid ${label}'
  },
  pattern: {
    mismatch: 'Enter a valid ${label}'
  }
}
